import {APPROVAL_STATUS} from '../../../../constants';

export const hasLockedInternalTime = timeReg => {
	const idleTime = timeReg.idleTime;
	const isInternalTime = idleTime?.isInternalTime;
	const approvalStatus = timeReg?.approvalStatus;

	return isInternalTime && [APPROVAL_STATUS.SUBMITTED, APPROVAL_STATUS.APPROVED].includes(approvalStatus);
};

export const timeEntryLockedInternalTime = (lineItem, dayRegs, isWeekView) => {
	const timeReg = lineItem.timeReg ? (lineItem.timeReg.node ? lineItem.timeReg.node : lineItem.timeReg) : lineItem;

	return isWeekView
		? dayRegs && dayRegs.length > 0 && dayRegs.some(tReg => hasLockedInternalTime(tReg.node))
		: hasLockedInternalTime(timeReg);
};
